



















































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat, downloadFile } from "@/utils/index";
@Component({
  name: "outboundDataStatisticsReport"
})
export default class outboundDataStatisticsReport extends Vue {
  private mounted() {
    window.document.body.addEventListener('click', (e: any) => {
      if(e.target.id) {
        if(e.target.id === (this.$refs.timeFlag as Vue).$attrs.id) {
          this.isTimeInput = true;
        }
      }else{
        this.isTimeInput = false;
      }
    });
  }
  @Provide() private isByHour: number = -1; //by Hour: 2, by date: 1;
  @Provide() private RangeType: number = -1; //by Hour: 2, by date: 1;
  @Provide() private pickTime: any = ""; // 小时
  @Provide() private timeList: number[] = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];
  @Provide() private isTimeInput: boolean = false;
  @Provide() private pickedHour: any = "00:00 - 23:00"; // 上次更新时间
  @Provide() private isClked: boolean = false;
  @Provide() private chosenTimeItem: number = 0;
  @Provide() private chosenTimeItemAnother: number = 23;
  @Provide() private isHoured: boolean = false; // 是否显示小时
  //  处理 日期时间选择操作
  private pickerAction() {
    let opt = this.searchForm.pickDate;
    var _maxDate=null;//初始化
    var _maxTime=null;//初始化
    let  _minDate = new Date(opt[0]);
    let _minTime = _minDate.getFullYear() + _minDate.getMonth() + _minDate.getDate();
    _maxDate = new Date(opt[1]);
    _maxTime = _maxDate.getFullYear() + _maxDate.getMonth() + _maxDate.getDate();
    if(_minTime === _maxTime){
      this.isHoured = true;
      this.isTimeInput = true;
      let timeFlagel: any = this.$refs.timeFlag;
      timeFlagel.focus();
      let _compareStamp = new Date(_minTime).getTime();
      let _hour =  _minDate.getDate();
      let _now = new Date();
      let _nowTimeStamp = new Date(_now.getFullYear() + _now.getMonth() + _now.getDate()).getTime();
      // 默认展示当前的小时，向上取整；如果不是当天展示23
      if(_compareStamp == _nowTimeStamp) {
        if(_hour == 23) {
          this.pickTime = 23;
        } else {
          this.pickTime = _now.getHours() + 1;
        }
      }else{
        this.pickTime = 23;
      }
    }else{
      this.isHoured = false;
    }
  }
  // lee 禁止输入时间
  private timeInputAction(evt: any) {
    evt = "";
  }
  private timeInputFocus(evt: any) {
    // this.chosenTimeItem = -1;
    // this.chosenTimeItemAnother = -1;
    setTimeout(() => {
      this.isTimeInput = true;
    }, 4);
  }
  private focusinTimeItem() {
    this.isTimeInput = true;
  }
  private pickTimeItem(item: number) {
    if(!this.isClked) {
      this.chosenTimeItem = item;
      this.isClked = true;
      this.isTimeInput = true;
    }else{
      this.chosenTimeItemAnother = item;
      this.isClked = false;
      setTimeout(() => {
        this.isTimeInput = false;
      }, 30);
      this.matchPickTime();
    }
  }	
  private matchPickTime() {
    if(this.chosenTimeItem > this.chosenTimeItemAnother) {
      [this.chosenTimeItemAnother, this.chosenTimeItem] = [this.chosenTimeItem,this.chosenTimeItemAnother];
    }
    this.pickedHour = (Number(this.chosenTimeItem) > 9 ? (this.chosenTimeItem + ':00'):('0'+this.chosenTimeItem + ':00'))+ ' - ' + (Number(this.chosenTimeItemAnother) > 9 ? (this.chosenTimeItemAnother + ':00'):('0'+this.chosenTimeItemAnother + ':00'));
  }
  private pickTimeItemNow() {
    this.chosenTimeItem = 0;
    this.chosenTimeItemAnother = (new Date()).getHours();
    setTimeout(() => {
      this.isTimeInput = false;
    }, 30);
    this.matchPickTime();
  }
  private searchFormActionByTime() {
    this.RangeType = 2;
    this.pageIndex = 1;
    if(this.testSearchForm()){
      this.getHourExtenList();
    }
  }
  @Provide() private queryDimension: any = []; // 查询维度
  @Provide() private dimensionList: any = [3]; // table Head查询维度
  private getUserStatusOptions() {
    this.queryDimension = [
      { value: 0, label: this.$t('formLgy.Date') }, // 日期 DATE
      { value: 1, label: this.$t('formLgy.Supplier') },  // 供应商 SUPPLIER
      { value: 2, label: this.$t('formLgy.ExtensionNumber') }, // 分机号码 EXTNUMBER
      { value: 3, label: this.$t('formLgy.Name') }, // 员工姓名 USER
      { value: 4, label: this.$t('tableLgy.EmployeeRole') }, // 员工角色 ROLE
      { value: 5, label: this.$t('formLgy.TicketCategory') } // 工单类型 ITEM
    ];
  };
  @Provide() private resultTicketItemData: any = []; // 工单类型列表
  @Provide() private resultSupplierData: any = []; // 供应商列表
  @Provide() private roleOptions: any = []; // 角色列表
  // lee 获取查询参数
  private async getExtenListParam() {
    const { getDialListParam }: any = await import("@/request/getDialList");
    let res = await getDialListParam();
    if (res) {
      this.resultTicketItemData = res && res.ticketitemList ? res.ticketitemList : []; // 工单类型列表
      this.resultSupplierData = res && res.supplierMap ? res.supplierMap : []; // 供应商列表
      this.roleOptions = res && res.roleidsList ? res.roleidsList : []; // 角色列表
    }
  }
  // 查询参数
  @Provide() private searchForm: any = {
    pickDate: "",
    supplier: "",
    extNumber: "",
    user: "",
    userID:"",
    roleIDs: "",
    itemID: "",
    dimension:[3]
  }; 
  // lee 搜索表单
  @Provide() private searchFormRules: any = {
    pickDate: [
      {
        type: "date",
        required: true,
        message: "pls choose time at least",
        trigger: "change"
      }
    ]
  };
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {},
    shortcuts: [
      {
        text: "Today",
        onClick(picker: any) {
          const start = new Date();
          const _starttime =
            start.getFullYear() +
            "-" +
            (start.getMonth() + 1) +
            "-" +
            start.getDate();
          start.setTime(new Date(_starttime).getTime());
          const end = new Date();
          end.setTime(end.getTime());
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Yesterday",
        onClick(picker: any) {
          const end = new Date();
          const _endtime =
            end.getFullYear() +
            "-" +
            (end.getMonth() + 1) +
            "-" +
            end.getDate();
          end.setTime(new Date(_endtime).getTime());
          const start = new Date();
          start.setTime(new Date(_endtime).getTime() - 24 * 60 * 60 * 1000);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Last 7 days",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }
    ],
    start: "00:00",
    step: "00:10",
    end: "23: 50"
  };
  @Provide() private pickDate: any = ""; // 时间范围
  @Provide() private resultData: any = [];
  // lee 升降序 1升2降
  // 20200819 有一个兆麟的傻子要求默认成2
  @Provide() private isByDay: boolean = false;
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private isExportFormActionDone: boolean = false;
  @Provide() private isSearchFormActionByDayDone: boolean = false;
  @Provide() private isExportFormActionByDayDone: boolean = false;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  private created() {
    this.getUserStatusOptions();
    this.getExtenListParam(); // 获取列表数据
  }
  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    if (this.searchForm.dimension.length > 0 && this.searchForm.pickDate) {
      return true;
    } else if(this.searchForm.dimension.length <= 0) {
      this.$message.error("Please select at least one query dimension!");
      return false;
    } else {
      this.$message.error("pls choose Time at least!");
      return false;
    }
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    if(this.RangeType === 2){
      this.getHourExtenList();
    } else {
      this.getExtenList();
    }
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    if(this.RangeType === 2){
      this.getHourExtenList();
    } else {
      this.getExtenList();
    }
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      if(this.RangeType === 2){
      this.getHourExtenList();
    } else {
      this.getExtenList();
    }
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    if(this.RangeType === 2){
      this.getHourExtenList();
    } else {
      this.getExtenList();
    }
  }
  //  lee 搜索操作
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.RangeType = 1;
      this.pagerCount = 0;
      this.pageIndex = 1;
      this.isSearchFormActionDone = true;
      this.getExtenList();
      setTimeout(() => {
        this.isByDay = false;
      }, 4);
    }
  }
  //  lee 导出操作
  private async exportFormAction() {
    this.isByDay = false;
    const { downloadcallRecordExcel }: any = await import(
      "@/request/callRecordData"
    );
    let response = await downloadcallRecordExcel(
      this.dwGetExtenListFuc(),
      this
    );
    this.isExportFormActionDone = response ? response.loading : false;
    if (response) {
      if(response.array[3] && response,response.array[3].length>0){
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        downloadFile(blob, response.array[2]);
      }
    }
  }
  // lee 获取列表
  private dwGetExtenListFuc() {
    let _arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      pickDate: this.searchForm.pickDate ? timeFormat(this.searchForm.pickDate[0]) + " - " + timeFormat(this.searchForm.pickDate[1]): null,
      supplier: this.searchForm.supplier,
      extNumber: this.searchForm.extNumber,
      user: this.searchForm.user,
      roleIDs: this.searchForm.roleIDs + "",
      itemID: this.searchForm.itemID,
      dimension: this.searchForm.dimension,
      userID: this.searchForm.userID
    };
    let chosenTimeItem =  timeFormat((new Date(this.searchForm.pickDate[0]).getTime())+(this.chosenTimeItem*60*60*1000));
    let chosenTimeItemAnother =  timeFormat((new Date(this.searchForm.pickDate[0]).getTime())+(this.chosenTimeItemAnother*60*60*1000));
    if (this.RangeType === 2){
      _arg.pickDate = this.searchForm.pickDate ? chosenTimeItem + " - " + chosenTimeItemAnother : null
    }
    return _arg;
  }
  // 查询
  private async getExtenList() {
    this.resultData = [];
    const { dialStats }: any = await import(
      "@/request/callRecordData"
    );
    let res = await dialStats(this.dwGetExtenListFuc(), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    this.isByHour = this.RangeType;
    if (res) {
      let _result =
        typeof res.dialstatsList == "object"
          ? res.dialstatsList
          : JSON.parse(res.dialstatsList);
      if (_result) {
        this.dimensionList = this.searchForm.dimension;
        this.resultData = _result;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  // 小时查询
  private async getHourExtenList() {
    this.resultData = [];
    const { dialStatsHour }: any = await import(
      "@/request/callRecordData"
    );
    let res = await dialStatsHour(this.dwGetExtenListFuc(), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    this.isByHour = this.RangeType;
    if (res) {
      let _result =
        typeof res.dialstatsList == "object"
          ? res.dialstatsList
          : JSON.parse(res.dialstatsList);
      if (_result) {
        this.dimensionList = this.searchForm.dimension;
        this.resultData = _result;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  //  lee 导出操作
  private async exportHourFormAction() {
    this.isByDay = false;
    const { downloadcallRecordHourExcel }: any = await import(
      "@/request/callRecordData"
    );
    let response = await downloadcallRecordHourExcel(
      this.dwGetExtenListFuc(),
      this
    );
    this.isExportFormActionDone = response ? response.loading : false;
    if (response) {
      if(response.array[3] && response,response.array[3].length>0){
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        downloadFile(blob, response.array[2]);
      }
    }
  }
}
